import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { updateSidebarView } from '../../../../../../redux/actions/sidebar';
import useRedirect from '../../../../../../hooks/useRedirect';

import imgURL from '../../../../../../lib/imgURL';
import { UiRoutes } from '../../../../../../lib/constants';
import { ProfileSteps } from './constants';

import { Props } from './typing';
import './style.scss';

const ProfileSideBar: FC<Props> = (props): JSX.Element => {
  const { push, generatePath } = useRedirect();
  const [profileSteps, setProfileSteps] = useState(ProfileSteps);
  const { currentStep, setCurrentStep, profileStatus } = props;

  useEffect(() => {
    setProfileSteps([
      ...profileSteps.map((val) => {
        if (currentStep === val.step) {
          val.active = true;
        } else {
          val.active = false;
        }

        if (profileStatus && profileStatus?.saved && profileStatus?.saved[val.step]) {
          val.saved = true;
        } else {
          val.saved = false;
        }

        if (profileStatus && (Number(profileStatus?.status) > 50 || profileStatus?.completed && profileStatus?.completed[val.step])) {
          val.completed = true;
        } else {
          val.completed = false;
        }
        
        return val;
      }),
    ]);
  }, [currentStep, profileStatus]);

  return (
    <React.Fragment>
      <div className='profile-sidebar'>
        <div className='logo'>
          <a href='#'>
            <img
              className='plural-logo'
              src={imgURL.logo}
              alt='Plural'
              onClick={(e) => {
                e.preventDefault();
                push(generatePath(UiRoutes.OVERVIEW));
              }}
            />
          </a>
        </div>
        <div className='step-container'>
          <div className='step-heading'>KYC Form</div>
          <div className='step-text'>
            Complete and submit the form to accept payments
          </div>
          <div className='step-values'>
            {profileSteps.map((val, index) => {
              return (
                <div
                  onClick={() => {
                    if(!(Number(profileStatus?.status) >= 50) && (val.saved || val.completed)){
                      setCurrentStep(val.step);
                    }
                  }}
                  key={`step-${index}`}
                  className={`step-val step-${index} ${val.label} ${
                    val.active ? 'active' : ''
                  } ${val.completed ? 'completed' : ''
                  } ${Number(profileStatus?.status) >= 50 ? 'freeze' : ''}`}
                >
                  {val.label}
                  {val.completed && <img src={imgURL.checkCirle} />}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ sidebarReducer, loginReducer }) => ({
  isCollapsed: sidebarReducer.isCollapsed,
  merchantId: loginReducer.loginState.MerchantId,
  isAdmin: loginReducer.loginState.isAdmin,
  merchantTPVEnabled: loginReducer?.loginState?.merchantTPVEnabled ?? false,
});

export default connect(mapStateToProps, {
  updateSidebarView,
})(ProfileSideBar);
